import { render, staticRenderFns } from "./WeighingLimit.vue?vue&type=template&id=3486605b"
import script from "./WeighingLimit.vue?vue&type=script&lang=js"
export * from "./WeighingLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports